"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _python = _interopRequireDefault(require("highlight.js/lib/languages/python"));

var _default = _python.default;
exports.default = _default;